import { Component, Input, inject } from "@angular/core";
import { Hss } from "../models/hss";
import { HssBuilderService } from "../hss-builder.service";
import { HssTimePipe } from "../pipes/hss-time.pipe";
import { HssDurationPipe } from "../pipes/hss-duration";
import { HssDutyPeriod } from "../models/hss-duty-period";
import { RapItem } from "../models/history";
import { DateTime } from "luxon";

@Component({
  selector: "app-dp-summary",
  standalone: true,
  imports: [HssTimePipe, HssDurationPipe],
  templateUrl: "./dp-summary.component.html",
  styleUrls: ["./dp-summary.component.scss", "../hss-builder.component.scss"],
})
export class DpSummaryComponent {
  @Input({ required: true }) hss!: Hss;
  @Input({ required: true }) dp!: HssDutyPeriod;
  @Input({ required: true }) dpState!: string;
  @Input({ required: true }) stationTimeZones!: Record<string, string>;
  @Input() raps: RapItem[] = [];
  @Input() enhanced?: boolean;
  @Input() index?: number;

  hssBuilderService = inject(HssBuilderService);

  isSplitDuty(): boolean {
    console.log(this.hss);
    if (this.hss) {
      for (const leg of this.hss.legs) {
        if (leg.oalSurfaceAirline.text === "SPT") {
          return true;
        }
      }
    }
    return false;
  }

  getSplitDutyStartDate(): string {
    if (this.dp) {
      return DateTime.fromFormat(
        this.dp.fdpStartAcclim.text,
        "MM/dd/yyyy HH:mm:ss",
        { zone: "UTC" },
      )
        .toFormat("ddMMM")
        .toUpperCase();
    }
    return "";
  }
}
